



























































































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin, DebtCustomerMixin} from "../../../../../shared/services/mixin";
import {ReceiptPickingListStore} from "@/modules/receiptsexpenses/receiptpickinglist/store";
import {ReceiptExpensePickingList} from "@/interfaces/entity/receiptExpensePickingList";
import {ClearingDebtType, ReceiptPaymentType} from "@/enums/type";
import moment from "moment";
import {FORMAT_DATE_TIME_PICKER} from "@/shared/constant";
import {DebtCustomer} from "@/interfaces/entity";
import {LadingStatus, ReceiptExpensePickingListPayStatus} from "@/enums/status";
import {ExpensePickingListStore} from "@/modules/receiptsexpenses/expensepickinglist/store";

@Component({
    name: "ExpenseCustomerPickingListPrint",
})
export default class extends mixins(CommonMixin, DebtCustomerMixin) {
    @Prop({ type: Boolean, default: false }) readonly isPrint!: boolean;
    @Prop({ required: true }) readonly id!: any;

    ReceiptPaymentType = ReceiptPaymentType;
    ReceiptExpensePickingListPayStatus = ReceiptExpensePickingListPayStatus;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    ClearingDebtType = ClearingDebtType;
    LadingStatus = LadingStatus;

    get pickingList(): ReceiptExpensePickingList {
        return ExpensePickingListStore.data[this.id];
    }

    get debts(): Array<DebtCustomer> {
        return this.getProp(this.pickingList, 'debtCustomers', []);
    }
}
